import { useSelector } from 'react-redux'
import { useAccount } from 'state/Account'
import { useServerConstants } from 'state/Constants'
import { getIsSingleEnabledRestaurant } from 'state/Restaurants'

/**
 * Returns if shipday is turned off globally and if that's their only way of delivery, returns that delivery in general is disabled.
 @param string type
 @param Restaurant restaurant
 * @return {{ isThirdPartyDeliveryDisabled: boolean, isDeliveryDisabled: boolean}}
 */
const useThirdPartyDeliveryStatus = (type, restaurant) => {
	const account = useAccount()
	const CONSTANTS = useServerConstants()
	const isSingleRest = useSelector(getIsSingleEnabledRestaurant)
	const isThirdPartyDeliveryDisabled = type == 'DELIVERY' && account.isShipdayOn(CONSTANTS.VALUES) && account.shipday_globally_disabled
	const isDeliveryDisabled = isThirdPartyDeliveryDisabled && restaurant?.shipday_auto_dispatch_enabled && isSingleRest
	return { isThirdPartyDeliveryDisabled, isDeliveryDisabled }
}
export default useThirdPartyDeliveryStatus